"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const step_paginator_styles_1 = __importDefault(require("./step-paginator.styles"));
const b = b_1.default.with('step-paginator');
function StepPaginator() {
    const { current = -1, length = 0 } = (0, react_redux_1.useSelector)((state) => {
        const { length } = state.pages.list;
        const current = state.pages.currentPage;
        return { current, length };
    });
    const i18n = (0, pythia_libs_1.i18n)(['ux', 'stepPaginator']);
    const step = i18n(['stepTitle'])
        .replace('%s', String(current + 1))
        .replace('%s', String(length));
    if (!length || current === -1) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("p", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: step_paginator_styles_1.default }), step] })));
}
exports.default = StepPaginator;
